export default __webpack_public_path__ + "static/add-1d4fde030bab5e36d8fe1ad0437bb80e.png";